export enum TenantSettingsEvent{
    ClickedProChipClickedUpgrade = 'TenantSettings.ClickedProChipClickedUpgrade',
    ClickedProChipClickedUpgradeContact = 'TenantSettings.ClickedProChipClickedUpgradeContact',
    ClickedProChipClickedUpgradeUpgrade = 'TenantSettings.ClickedProChipClickedUpgradeUpgrade',
}
